import type { SelectPromoModelResponse } from '../types/promozavr';
import { selectPromoModelResponseSchema } from './promozavr-schema';

export function isSelectPromoModelResponse(value: unknown): value is SelectPromoModelResponse {
    return selectPromoModelResponseSchema.safeParse(value).success;
}
